import React from "react";
export function composeEventHandlers(theirHandler, ourHandler) {
    return function(event) {
        if (theirHandler) {
            theirHandler(event);
        }
        if (!event.defaultPrevented) {
            return ourHandler(event);
        }
    };
}
export default composeEventHandlers;
